import React, { useState, useEffect } from 'react';
import { getSettings } from '../../services/api';
import { Camera, User, Mountain, Briefcase, Palette } from 'lucide-react';
import useReveal from '../../hooks/useReveal';
import '../../styles/about.css';

const About = () => {
  const [photographerInfo, setPhotographerInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const settings = await getSettings();
        setPhotographerInfo({
          name: settings.photographer_name,
          bio: settings.bio
        });
        setLoading(false);
      } catch (error) {
        console.error('Error loading about data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useReveal([loading]);

  if (loading) {
    return (
      <section className="about-section" id="about">
        <div className="about-container">
          <p>Loading...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <span className="about-label" data-reveal>About Me</span>
            <h2 className="about-title" data-reveal style={{ '--reveal-delay': '120ms' }}>Crafting Visual Stories</h2>
            <p className="about-bio" data-reveal style={{ '--reveal-delay': '240ms' }}>{photographerInfo?.bio}</p>
            <div className="about-specialties">
              <h3 className="specialties-title" data-reveal>Specializations</h3>
              <div className="specialties-grid">
                <div className="specialty-item" data-reveal>
                  <div className="specialty-icon"><Camera size={32} /></div>
                  <h4>Events</h4>
                  <p>Weddings, corporate gatherings, and live performances</p>
                </div>
                <div className="specialty-item" data-reveal style={{ '--reveal-delay': '120ms' }}>
                  <div className="specialty-icon"><User size={32} /></div>
                  <h4>Portraits</h4>
                  <p>Personal branding and artistic self-expression</p>
                </div>
                <div className="specialty-item" data-reveal style={{ '--reveal-delay': '240ms' }}>
                  <div className="specialty-icon"><Mountain size={32} /></div>
                  <h4>Landscapes</h4>
                  <p>Nature's beauty captured in stunning detail</p>
                </div>
                <div className="specialty-item" data-reveal style={{ '--reveal-delay': '360ms' }}>
                  <div className="specialty-icon"><Briefcase size={32} /></div>
                  <h4>Commercial</h4>
                  <p>Product photography and brand campaigns</p>
                </div>
                <div className="specialty-item" data-reveal style={{ '--reveal-delay': '480ms' }}>
                  <div className="specialty-icon"><Palette size={32} /></div>
                  <h4>Fine Art</h4>
                  <p>Creative expressions and conceptual work</p>
                </div>
              </div>
            </div>
          </div>
          <div className="about-image" data-reveal style={{ '--reveal-delay': '200ms' }}>
            <div className="about-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=600&q=80" 
                alt="Photographer at work"
              />
              <div className="about-image-overlay">
                <div className="overlay-text">
                  <p className="overlay-stat">10+</p>
                  <p className="overlay-label">Years Experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;